var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xkw-table"},[_c('h3',[_vm._v(_vm._s(_vm.tableName))]),_c('el-table',_vm._g(_vm._b({ref:"xkw-table",attrs:{"header-cell-style":{
      color: '#333',
      background: '#f8f8f9',
      'text-align': 'center',
    }}},'el-table',_vm.finalProps,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }